import React, { useState, useEffect, useRef } from "react";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import {
  Typography,
  IconButton,
  Box,
  Button,
  Chip,
  Tooltip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  CircularProgress,
  Snackbar,
  Avatar,
  Divider,
  Paper,
  useMediaQuery,
  useTheme,
  LinearProgress,
  Grid
} from "@mui/material";
import { pesquisaApi } from "../../services/apiPesquisa.servise";
import { formState } from "../../store/reducers/data";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ImageIcon from '@mui/icons-material/Image';
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import RouteIcon from '@mui/icons-material/Route';
import StraightenIcon from '@mui/icons-material/Straighten';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setHeader } from "../../store/reducers/dadosHeader";
import {
  saveChange,
  setAllSegments,
  setImagens,
} from "../../store/reducers/dadosSegmentos";
import cloneDeep from "lodash.clonedeep";
import { authService } from "../../services/auth.service";
import { ModalComp } from "../Modal/Modal";
import DownloadIcon from '@mui/icons-material/Download';
const formatDuration = (start, end) => {
  if (!start || !end) return null;
  try {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffMs = endDate - startDate;
    if (diffMs < 0) return null;

    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHours = Math.floor(diffMin / 60);
    const diffDays = Math.floor(diffHours / 24);
    const remainingHours = diffHours % 24;
    const remainingMin = diffMin % 60;

    if (diffDays > 0) {
      return `${diffDays}d ${remainingHours}h ${remainingMin}min`;
    } else if (diffHours > 0) {
      return `${diffHours}h ${remainingMin}min`;
    } else if (diffMin > 0) {
      return `${diffMin}min`;
    } else {
      return `${diffSec}s`;
    }
  } catch (e) {
    return null;
  }
};

const statusConfig = {
  IN_PROGRESS: { label: 'Em Andamento', color: 'info' },
  REVIEW: { label: 'Em Revisão', color: 'warning' },
  COMPLETED: { label: 'Concluído', color: 'success' },
};

export function CodificationItem({
  codificationTitle,
  lastSectionName,
  lastDateAlteretion,
  hasImgs,
  idHeader,
  item,
  onUpdate,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [uploadingSheet, setUploadingSheet] = useState(false);
  const fileInputRef = useRef(null);
  const user = authService.getLoggedUser();
  const isAdm = user?.isAdm || false;

  const currentStatus = item?.status || 'IN_PROGRESS';
  const statusDisplay = item?.status_display || statusConfig[currentStatus]?.label || 'Em Andamento';
  const [downloadingImages, setDownloadingImages] = useState(false);
  const startedAt = item?.started_at;
  const completedAt = item?.completed_at;
  const duration = ((currentStatus === 'COMPLETED' || currentStatus === 'REVIEW') && startedAt && completedAt)
    ? formatDuration(startedAt, completedAt)
    : null;

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [hasDeleted, setHasDeleted] = useState(false);
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [editing, setEditing] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [importErrors, setImportErrors] = useState([]);
  const [openImportErrorModal, setOpenImportErrorModal] = useState(false);
  const [editForm, setEditForm] = useState({
    road_name: '',
    section_name: '',
    coder: '',
    status: currentStatus
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  // Determina se o formulário de codificação (selects) está bloqueado
  const isFormDisabled = () => {
    if (currentStatus === 'COMPLETED') return true;
    if (currentStatus === 'REVIEW' && !isAdm) return true;
    return false;
  };
  // Função para lidar com o upload
  const handleSheetUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
      setSnackbar({ open: true, message: 'Formato inválido. Use .xlsx ou .xls', severity: 'error' });
      return;
    }

    setUploadingSheet(true);
    try {
      const result = await pesquisaApi.uploadSheet(idHeader, file);
      if (result.success) {
        setSnackbar({ open: true, message: 'Planilha importada com sucesso!', severity: 'success' });
        setOpenEditModal(false);
        if (onUpdate) onUpdate();
      } else {
        if (result.errors && result.errors.length > 0) {
          setImportErrors(result.errors);
          setOpenImportErrorModal(true);
        } else {
          setSnackbar({ open: true, message: result.message || 'Erro ao importar', severity: 'error' });
        }
      }
    } catch (errorData) {
      if (errorData.errors && errorData.errors.length > 0) {
        setImportErrors(errorData.errors);
        setOpenImportErrorModal(true);
      } else {
        setSnackbar({
          open: true,
          message: errorData.message || 'Erro ao importar planilha',
          severity: 'error'
        });
      }
    } finally {
      setUploadingSheet(false);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };
  useEffect(() => {
    const loadUsers = async () => {
      if (openEditModal) {
        setLoadingUsers(true);
        try {
          const usersList = await pesquisaApi.getAllUsers();
          setUsers(usersList);
        } catch (error) {
          console.error('Erro ao carregar usuários:', error);
          setSnackbar({
            open: true,
            message: 'Erro ao carregar lista de usuários',
            severity: 'error'
          });
        } finally {
          setLoadingUsers(false);
        }
      }
    };
    loadUsers();
  }, [openEditModal]);

  useEffect(() => {
    if (openEditModal && item) {
      setEditForm({
        road_name: item.road_name || '',
        section_name: item.section_name || '',
        coder: item.coder?.id || item.coder || '',
        status: item.status || 'IN_PROGRESS'
      });
    }
  }, [openEditModal, item]);

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleEditChange = (field, value) => {
    setEditForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSaveEdit = async () => {
    if (!editForm.road_name.trim() || !editForm.section_name.trim()) {
      setSnackbar({
        open: true,
        message: 'Nome da via e trecho são obrigatórios',
        severity: 'warning'
      });
      return;
    }

    setEditing(true);
    try {
      const dataToUpdate = {
        road_name: editForm.road_name.trim(),
        section_name: editForm.section_name.trim()
      };

      if (isAdm && editForm.coder && editForm.coder !== item.coder?.id) {
        dataToUpdate.coder = editForm.coder;
      }
      if (isAdm && editForm.status && editForm.status !== item.status) {
        dataToUpdate.status = editForm.status;
      }

      await pesquisaApi.updateHeader(idHeader, dataToUpdate);

      setSnackbar({
        open: true,
        message: 'Codificação atualizada com sucesso!',
        severity: 'success'
      });

      setOpenEditModal(false);
      if (onUpdate) onUpdate();

    } catch (error) {
      console.error('Erro ao atualizar codificação:', error);
      setSnackbar({
        open: true,
        message: `Erro ao atualizar: ${error.message}`,
        severity: 'error'
      });
    } finally {
      setEditing(false);
    }
  };

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await pesquisaApi.deleteHeader(idHeader);
      setSnackbar({
        open: true,
        message: 'Codificação excluída com sucesso!',
        severity: 'success'
      });
      setHasDeleted(true);
      setOpenDeleteModal(false);
      setTimeout(() => {
        if (onUpdate) onUpdate();
      }, 1000);
    } catch (error) {
      console.error('Erro ao excluir codificação:', error);
      setSnackbar({
        open: true,
        message: `Erro ao excluir: ${error.message}`,
        severity: 'error'
      });
    } finally {
      setDeleting(false);
    }
  };
  const handleDownloadImages = async () => {
    setDownloadingImages(true);
    try {
      await pesquisaApi.downloadHeaderImages(idHeader, item?.road_name || '');
      setSnackbar({
        open: true,
        message: 'Download das imagens iniciado!',
        severity: 'success'
      });
    } catch (error) {
      console.error('Erro ao baixar imagens:', error);
      setSnackbar({
        open: true,
        message: `Erro ao baixar imagens: ${error.message}`,
        severity: 'error'
      });
    } finally {
      setDownloadingImages(false);
    }
  };
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return dateString;
    }
  };

  const onClickHeaderHandler = async () => {
    const dataPayload = {
      dadosTabelaDeReferencia: JSON.parse(item.data_reference_table),
      idHeader: idHeader,
      RoadName: item.road_name,
      snippet: item.section_name,
      distance: item.distance,
      status: item.status,
      status_display: item.status_display,
      started_at: item.started_at,
      completed_at: item.completed_at
    };
    dispatch(setHeader(dataPayload));

    if (hasImgs) {
      const res = await pesquisaApi.getSections(idHeader);
      let arrayState = Array(res.data.length)
        .fill()
        .map(() => cloneDeep(formState));
      let data = await res.data;
      data.sort((a, b) => a.id_section - b.id_section);
      let imagens = [];
      data.forEach((obj, i) => {
        for (let _data in data[i]) {
          if (
            _data === "centre_0" ||
            _data === "centre_20" ||
            _data === "centre_40" ||
            _data === "centre_60" ||
            _data === "centre_80"
          ) {
            imagens.push(data[i][_data]);
          }
        }
      });
      dispatch(setImagens({ imagens: imagens }));

      arrayState.forEach((item, i) => {
        item.forEach((parametro, j) => {
          for (let datas in data[i]) {
            if (datas === parametro.varName) {
              parametro.selecionado.code = data[i][datas];
              parametro.label.forEach((option) => {
                if (option.code === data[i][datas]) {
                  parametro.selecionado.title = option.title;
                }
              });
              arrayState[i][j].selecionado.code = data[i][datas];
            }
          }
        });
      });

      dispatch(saveChange());
      dispatch(
        setAllSegments({ segmentos: arrayState, length: arrayState.length })
      );
      navigate('/search');
    } else {
      navigate("/uploadImages", { state: { reload: false } });
    }
  };

  const truncateText = (text, maxLength) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  // Modal de edição
  const renderEditModal = () => (
    <Dialog
      open={openEditModal}
      onClose={() => setOpenEditModal(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: 'var(--goia-surface-raised)',
          color: 'var(--goia-text)',
        }
      }}
    >
      <DialogTitle sx={{ color: 'var(--goia-navy)' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EditIcon sx={{ color: 'var(--goia-orange)' }} />
          Editar Codificação #{idHeader}
        </Box>
      </DialogTitle>

      <DialogContent dividers sx={{ borderColor: 'var(--goia-border)' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <TextField
            label="Nome da Via"
            variant="outlined"
            size="small"
            value={editForm.road_name}
            onChange={(e) => handleEditChange('road_name', e.target.value)}
            fullWidth
            disabled={editing}
          />
          <TextField
            label="Trecho"
            variant="outlined"
            size="small"
            value={editForm.section_name}
            onChange={(e) => handleEditChange('section_name', e.target.value)}
            fullWidth
            disabled={editing}
          />

          {isAdm && (
            <FormControl size="small" fullWidth disabled={editing}>
              <InputLabel>Status</InputLabel>
              <Select
                value={editForm.status}
                label="Status"
                onChange={(e) => handleEditChange('status', e.target.value)}
              >
                <MenuItem value="IN_PROGRESS">Em Andamento</MenuItem>
                <MenuItem value="REVIEW">Em Revisão</MenuItem>
                <MenuItem value="COMPLETED">Concluído</MenuItem>
              </Select>
            </FormControl>
          )}

          {isAdm && (
            <FormControl size="small" fullWidth disabled={editing || loadingUsers}>
              <InputLabel>Codificador</InputLabel>
              <Select
                value={editForm.coder}
                label="Codificador"
                onChange={(e) => handleEditChange('coder', e.target.value)}
              >
                {loadingUsers ? (
                  <MenuItem value="">
                    <CircularProgress size={20} />
                    Carregando usuários...
                  </MenuItem>
                ) : (
                  users.map(user => (
                    <MenuItem key={user.id} value={user.id}>
                      {user.username} ({user.email})
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          )}

          <Paper
            elevation={0}
            sx={{
              p: 2,
              mt: 2,
              backgroundColor: 'var(--goia-surface)',
              borderRadius: 2,
              border: '1px solid var(--goia-border)',
            }}
          >
            <Grid container spacing={2}>
              {/* Data de criação */}
              <Grid item xs={12} sm={6}>
                <Box display="flex" alignItems="center" gap={1}>
                  <CalendarTodayIcon fontSize="small" sx={{ color: 'var(--goia-text-muted)' }} />
                  <Box>
                    <Typography variant="caption" color="textSecondary" display="block">
                      Data de criação
                    </Typography>
                    <Typography variant="body2" fontWeight={500}>
                      {formatDate(item.coding_date)}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Status atual */}
              <Grid item xs={12} sm={6}>
                <Chip
                  label={statusDisplay}
                  size="small"
                  color={statusConfig[currentStatus]?.color || 'default'}
                  sx={{ fontWeight: 'bold', ml: 4 }}
                />

              </Grid>

              {/* Iniciado em (se disponível) */}
              {item.started_at && (
                <Grid item xs={12} sm={6}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <AccessTimeIcon fontSize="small" sx={{ color: 'var(--goia-text-muted)' }} />
                    <Box>
                      <Typography variant="caption" color="textSecondary" display="block">
                        Iniciado em
                      </Typography>
                      <Typography variant="body2" fontWeight={500}>
                        {formatDateTime(item.started_at)}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              )}

              {/* Concluído em (se disponível) */}
              {item.completed_at && (
                <Grid item xs={12} sm={6}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <AccessTimeIcon fontSize="small" sx={{ color: 'var(--goia-text-muted)' }} />
                    <Box>
                      <Typography variant="caption" color="textSecondary" display="block">
                        Concluído em
                      </Typography>
                      <Typography variant="body2" fontWeight={500}>
                        {formatDateTime(item.completed_at)}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              )}

              {/* Tempo de codificação (se concluído) */}
              {duration && (
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{
                      p: 1.5,
                      borderRadius: 2,
                      backgroundColor: 'var(--goia-success-100)',
                      border: '1px solid var(--goia-success)',
                    }}
                  >
                    <AccessTimeIcon sx={{ color: 'var(--goia-success)' }} />
                    <Box>
                      <Typography variant="caption" color="textSecondary" display="block">
                        Tempo de codificação
                      </Typography>
                      <Typography variant="body1" fontWeight="bold" color="var(--goia-success)">
                        {duration}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Paper>

          <Alert severity="info" sx={{
            backgroundColor: 'var(--goia-info-100)',
            color: 'var(--goia-text)',
            '& .MuiAlert-icon': { color: 'var(--goia-info)' }
          }}>
            <Typography variant="body2">
              {hasImgs ? 'Com imagens' : 'Sem imagens'}
            </Typography>
          </Alert>
          {isAdm && (
            <Box sx={{ mt: 2 }} >
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" color="primary" gutterBottom>
                Importar Planilha
              </Typography>
              <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 1 }}>
                Faça upload de uma planilha .xlsx ou .xls preenchida para atualizar todas as seções.
              </Typography>
              <div align='center' >
                <Button
                  variant="outlined"
                  component="label"
                  disabled={uploadingSheet}
                  startIcon={uploadingSheet ? <CircularProgress size={20} /> : <CloudUploadIcon />}
                >
                  {uploadingSheet ? 'Enviando...' : 'Selecionar Planilha'}
                  <input
                    type="file"
                    ref={fileInputRef}
                    accept=".xlsx,.xls"
                    hidden
                    onChange={handleSheetUpload}
                    disabled={uploadingSheet}
                  />
                </Button>
              </div>
            </Box>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ borderTop: '1px solid var(--goia-border)', p: 2 }}>
        <Button onClick={() => setOpenEditModal(false)} disabled={editing}>
          Cancelar
        </Button>
        <Button
          onClick={handleSaveEdit}
          variant="contained"
          color="primary"
          disabled={editing}
          startIcon={editing ? <CircularProgress size={20} /> : null}
          sx={{
            backgroundColor: 'var(--goia-navy)',
            '&:hover': { backgroundColor: 'var(--goia-navy-600)' },
          }}
        >
          {editing ? 'Salvando...' : 'Salvar Alterações'}
        </Button>
      </DialogActions>
    </Dialog>
  );

  const renderDeleteModal = () => (
    <Dialog
      open={openDeleteModal}
      onClose={() => setOpenDeleteModal(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: 'var(--goia-surface-raised)',
          color: 'var(--goia-text)',
        }
      }}
    >
      <DialogTitle sx={{ color: 'var(--goia-danger)' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <DeleteIcon sx={{ color: 'var(--goia-danger)' }} />
          Confirmar Exclusão
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Tem certeza que deseja excluir a codificação <strong>#{idHeader}</strong>?
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Via: {codificationTitle}
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Trecho: {lastSectionName}
        </Typography>
        <Alert severity="error" sx={{
          mt: 2,
          backgroundColor: 'var(--goia-danger-100)',
          color: 'var(--goia-text)',
          '& .MuiAlert-icon': { color: 'var(--goia-danger)' }
        }}>
          <Typography variant="body2">
            <strong>Atenção:</strong> Esta ação é irreversível e excluirá:
            <ul>
              <li>Todos os dados da codificação</li>
              <li>Todas as seções associadas</li>
              <li>Todas as imagens vinculadas</li>
            </ul>
          </Typography>
        </Alert>
      </DialogContent>

      <DialogActions sx={{ borderTop: '1px solid var(--goia-border)', p: 2 }}>
        <Button onClick={() => setOpenDeleteModal(false)} disabled={deleting}>
          Cancelar
        </Button>
        <Button
          onClick={handleDelete}
          variant="contained"
          startIcon={deleting ? <CircularProgress size={20} /> : <DeleteIcon />}
          disabled={deleting}
          sx={{
            backgroundColor: 'var(--goia-danger)',
            '&:hover': { backgroundColor: '#b53a3a' },
          }}
        >
          {deleting ? 'Excluindo...' : 'Excluir Permanentemente'}
        </Button>
      </DialogActions>
    </Dialog>
  );

  // Layout desktop
  const renderDesktopLayout = () => (
    <Paper
      elevation={1}
      sx={{
        mb: 2,
        borderRadius: 2,
        overflow: 'hidden',
        border: '1px solid var(--goia-border)',
        backgroundColor: 'var(--goia-surface-raised)',
        '&:hover': {
          boxShadow: 3,
          borderColor: 'var(--goia-orange)'
        }
      }}
    >
      <Box sx={{
        display: "flex",
        minHeight: "120px",
        backgroundColor: 'var(--goia-surface-raised)'
      }}>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            p: 2,
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: 'var(--goia-orange-100)'
            }
          }}
          onClick={onClickHeaderHandler}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  bgcolor: hasImgs ? 'var(--goia-success)' : 'var(--goia-gray-500)',
                  fontSize: '0.875rem'
                }}
              >
                {hasImgs ? <ImageIcon fontSize="small" /> : <ImageNotSupportedIcon fontSize="small" />}
              </Avatar>
              <Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1 }}>
                  ID: #{idHeader}
                </Typography>
                <Chip
                  label={hasImgs ? 'Com imagens' : 'Sem imagens'}
                  size="small"
                  color={hasImgs ? "success" : "default"}
                  variant="outlined"
                  sx={{
                    height: 20,
                    fontSize: '0.65rem',
                    borderColor: hasImgs ? 'var(--goia-success)' : 'var(--goia-gray-500)',
                    color: hasImgs ? 'var(--goia-success)' : 'var(--goia-text-muted)'
                  }}
                />
              </Box>
            </Box>

            <Typography
              variant="h6"
              component="div"
              sx={{
                color: 'var(--goia-navy)',
                fontWeight: 600,
                fontSize: isTablet ? '0.95rem' : '1.1rem',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                flex: 1,
                ml: 2,
                mr: 1,
                textAlign: 'center'
              }}
            >
              {truncateText(codificationTitle, isTablet ? 40 : 60)}
            </Typography>
          </Box>

          <Divider sx={{ my: 1, borderColor: 'var(--goia-border)' }} />

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, flex: 1, alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: '200px', flex: isTablet ? '1 1 100%' : '0 1 auto' }}>
              <RouteIcon fontSize="small" sx={{ color: 'var(--goia-text-muted)' }} />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                  Trecho
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    color: 'var(--goia-text)',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {truncateText(lastSectionName, isTablet ? 25 : 35)}
                </Typography>
              </Box>
            </Box>

            {item.distance && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: isTablet ? '1 1 100%' : '0 1 auto' }}>
                <StraightenIcon fontSize="small" sx={{ color: 'var(--goia-text-muted)' }} />
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                    Distância
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500, color: 'var(--goia-text)' }}>
                    {item.distance} m
                  </Typography>
                </Box>
              </Box>
            )}

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: isTablet ? '1 1 100%' : '0 1 auto' }}>
              <CalendarTodayIcon fontSize="small" sx={{ color: 'var(--goia-text-muted)' }} />
              <Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                  Data de Criação
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, color: 'var(--goia-text)' }}>
                  {formatDate(item.coding_date)}
                </Typography>
              </Box>
            </Box>

            {item.coder_username && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: isTablet ? '1 1 100%' : '0 1 auto' }}>
                <PersonIcon fontSize="small" sx={{ color: 'var(--goia-text-muted)' }} />
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                    Codificador
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      color: 'var(--goia-text)',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {truncateText(item.coder_username, isTablet ? 20 : 25)}
                  </Typography>
                </Box>
              </Box>
            )}

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip
                label={statusDisplay}
                color={statusConfig[currentStatus]?.color || 'default'}
                size="small"
                sx={{ fontWeight: 'bold' }}
              />
              {duration && (
                <Tooltip title={`Iniciado em ${formatDateTime(startedAt)}, concluído em ${formatDateTime(completedAt)}`}>
                  <Chip
                    icon={<AccessTimeIcon fontSize="small" />}
                    label={duration}
                    size="small"
                    color="success"
                    variant="outlined"
                  />
                </Tooltip>
              )}
            </Box>

            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              width: '100%',
              mt: 1
            }}>
              <Typography variant="caption" color="text.secondary" sx={{ minWidth: 65 }}>
                Progresso:
              </Typography>
              <LinearProgress
                variant="determinate"
                value={item.progress || 0}
                sx={{
                  flex: 1,
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: 'var(--goia-gray-light)',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor:
                      item.progress >= 80 ? 'var(--goia-success)' :
                        item.progress >= 50 ? 'var(--goia-orange)' : 'var(--goia-danger)'
                  }
                }}
              />
              <Typography variant="h9" fontWeight="bold" sx={{ minWidth: 40, color: 'var(--goia-text)' }}>
                {item.progress || 0}%
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: isTablet ? '60px' : '80px',
            borderLeft: '1px solid var(--goia-border)',
            backgroundColor: 'var(--goia-surface)'
          }}
        >
          <Box
            sx={{
              flex: 3,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderBottom: '1px solid var(--goia-border)',
              backgroundColor: 'var(--goia-navy)',
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: 'var(--goia-navy-600)',
              }
            }}
            onClick={onClickHeaderHandler}
          >
            <Box sx={{ textAlign: 'center' }}>
              <VisibilityIcon sx={{ color: 'var(--goia-text-on-brand)', mb: 0.5, fontSize: isTablet ? '1rem' : '1.25rem' }} />
              <Typography
                variant="caption"
                sx={{
                  color: 'var(--goia-text-on-brand)',
                  fontWeight: 600,
                  display: isTablet ? 'none' : 'block',
                  fontSize: '0.7rem'
                }}
              >
                Visualizar
              </Typography>
            </Box>
          </Box>

          {isAdm && (
            <Box
              sx={{
                flex: 3,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {/* EDITAR + EXCLUIR */}
              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  borderBottom: '1px solid var(--goia-border)',
                }}
              >
                {/* EDITAR */}
                <Tooltip title="Editar" placement="left">
                  <Box
                    sx={{
                      flex: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRight: '1px solid var(--goia-border)',
                      cursor: 'pointer',
                      backgroundColor: 'var(--goia-orange)',
                      '&:hover': {
                        backgroundColor: 'var(--goia-orange-100)',
                        '& .MuiSvgIcon-root': {
                          color: 'var(--goia-orange)',
                        },
                      },
                    }}
                    onClick={() => setOpenEditModal(true)}
                  >
                    <EditIcon
                      sx={{
                        color: 'var(--goia-text-on-brand)',
                        fontSize: isTablet ? '1rem' : '1.25rem',
                      }}
                    />
                  </Box>
                </Tooltip>

                {/* EXCLUIR */}
                <Tooltip title="Excluir" placement="left">
                  <Box
                    sx={{
                      flex: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer',
                      backgroundColor: 'var(--goia-danger)',
                      '&:hover': {
                        backgroundColor: 'var(--goia-danger-100)',
                        '& .MuiSvgIcon-root': {
                          color: 'var(--goia-danger)',
                        },
                      },
                    }}
                    onClick={() => setOpenDeleteModal(true)}
                  >
                    <DeleteIcon
                      sx={{
                        color: 'var(--goia-text-on-brand)',
                        fontSize: isTablet ? '1rem' : '1.25rem',
                      }}
                    />
                  </Box>
                </Tooltip>
              </Box>

              <Tooltip title="Baixar todas as imagens" placement="left">
                <Box
                  sx={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 0.7,
                    cursor: downloadingImages ? 'wait' : 'pointer',
                    backgroundColor: 'var(--goia-info)',
                    opacity: downloadingImages ? 0.6 : 1,
                    '&:hover': {
                      backgroundColor: 'var(--goia-info-200)',
                      '& .MuiSvgIcon-root': {
                        color: 'var(--goia-info)',
                      },
                      '& .MuiTypography-root': {
                        color: 'var(--goia-info)',
                      },
                    },
                  }}
                  onClick={
                    downloadingImages
                      ? undefined
                      : handleDownloadImages
                  }
                >
                  {downloadingImages ? (
                    <CircularProgress
                      size={isTablet ? 16 : 20}
                      sx={{ color: 'var(--goia-text-on-brand)' }}
                    />
                  ) : (
                    <>
                      <DownloadIcon
                        sx={{
                          color: 'var(--goia-text-on-brand)',
                          fontSize: isTablet ? '1rem' : '1.15rem',
                          transition: 'color 200ms ease',
                        }}
                      />

                      {!isTablet && (
                        <Typography
                          variant="caption"
                          sx={{
                            color: 'var(--goia-text-on-brand)',
                            fontWeight: 600,
                            fontSize: '0.65rem',
                            transition: 'color 200ms ease',
                          }}
                        >
                          Imagens
                        </Typography>
                      )}
                    </>
                  )}
                </Box>
              </Tooltip>
            </Box>
          )}
        </Box>
      </Box>
    </Paper>
  );

  // Layout mobile
  const renderMobileLayout = () => (
    <Paper
      elevation={1}
      sx={{
        mb: 2,
        borderRadius: 2,
        overflow: 'hidden',
        border: '1px solid var(--goia-border)',
        backgroundColor: 'var(--goia-surface-raised)',
        '&:hover': {
          boxShadow: 3,
          borderColor: 'var(--goia-orange)'
        }
      }}
    >
      <Box sx={{
        display: "flex",
        flexDirection: 'column',
        backgroundColor: 'var(--goia-surface-raised)'
      }}>
        <Box
          sx={{
            display: 'flex',
            p: 1.5,
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: 'var(--goia-orange-100)'
            }
          }}
          onClick={onClickHeaderHandler}
        >
          <Avatar
            sx={{
              width: 40,
              height: 40,
              bgcolor: hasImgs ? 'var(--goia-success)' : 'var(--goia-gray-500)',
              mr: 1.5
            }}
          >
            {hasImgs ? <ImageIcon /> : <ImageNotSupportedIcon />}
          </Avatar>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
              <Typography
                variant="subtitle1"
                component="div"
                sx={{
                  color: 'var(--goia-navy)',
                  fontWeight: 600,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  flex: 1
                }}
              >
                {truncateText(codificationTitle, 30)}
              </Typography>
              <Chip
                label={hasImgs ? 'Com imagens' : 'Sem imagens'}
                size="small"
                color={hasImgs ? "success" : "default"}
                variant="outlined"
                sx={{
                  height: 20,
                  fontSize: '0.6rem',
                  flexShrink: 0,
                  borderColor: hasImgs ? 'var(--goia-success)' : 'var(--goia-gray-500)',
                  color: hasImgs ? 'var(--goia-success)' : 'var(--goia-text-muted)'
                }}
              />
            </Box>

            <Typography variant="caption" color="text.secondary">
              ID: #{idHeader} • Trecho: {truncateText(lastSectionName, 20)}
            </Typography>
            <Box sx={{ mt: 0.5, display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
              <Chip
                label={statusDisplay}
                size="small"
                color={statusConfig[currentStatus]?.color || 'default'}
                sx={{ height: 20, fontSize: '0.6rem' }}
              />
              {duration && (
                <Chip
                  icon={<AccessTimeIcon sx={{ fontSize: '0.8rem' }} />}
                  label={duration}
                  size="small"
                  color="success"
                  variant="outlined"
                  sx={{ height: 20, fontSize: '0.6rem' }}
                />
              )}
            </Box>
          </Box>
        </Box>

        <Divider sx={{ borderColor: 'var(--goia-border)' }} />

        <Box sx={{ p: 1.5, display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
          {item.distance && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <StraightenIcon fontSize="small" sx={{ color: 'var(--goia-text-muted)' }} />
              <Typography variant="caption" color="text.secondary">
                {item.distance}m
              </Typography>
            </Box>
          )}

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <CalendarTodayIcon fontSize="small" sx={{ color: 'var(--goia-text-muted)' }} />
            <Typography variant="caption" color="text.secondary">
              {formatDate(lastDateAlteretion)}
            </Typography>
          </Box>

          {item.coder_username && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flex: '1 1 100%' }}>
              <PersonIcon fontSize="small" sx={{ color: 'var(--goia-text-muted)' }} />
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                {truncateText(item.coder_username, 25)}
              </Typography>
            </Box>
          )}

          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            width: '100%',
            mt: 0.5
          }}>
            <Typography variant="caption" color="text.secondary" sx={{ minWidth: 65 }}>
              Progresso:
            </Typography>
            <LinearProgress
              variant="determinate"
              value={item.progress || 0}
              sx={{
                flex: 1,
                height: 6,
                borderRadius: 4,
                backgroundColor: 'var(--goia-gray-light)',
                '& .MuiLinearProgress-bar': {
                  backgroundColor:
                    item.progress >= 80 ? 'var(--goia-success)' :
                      item.progress >= 50 ? 'var(--goia-orange)' : 'var(--goia-danger)'
                }
              }}
            />
            <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 35, color: 'var(--goia-text)' }}>
              {item.progress || 0}%
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderColor: 'var(--goia-border)' }} />

        <Box sx={{ display: 'flex' }}>
          <Button
            fullWidth
            variant="text"
            size="small"
            startIcon={<VisibilityIcon />}
            onClick={onClickHeaderHandler}
            sx={{
              py: 1,
              borderRadius: 0,
              borderRight: '1px solid var(--goia-border)',
              color: 'var(--goia-navy)',
              '&:hover': { backgroundColor: 'var(--goia-navy-600)', color: 'var(--goia-text-on-brand)' }
            }}
          >
            Visualizar
          </Button>
          {isAdm && (
            <>
              <Button
                fullWidth
                variant="text"
                size="small"
                startIcon={<EditIcon />}
                onClick={() => setOpenEditModal(true)}
                sx={{
                  py: 1,
                  borderRadius: 0,
                  borderRight: '1px solid var(--goia-border)',
                  color: 'var(--goia-orange)',
                  '&:hover': { backgroundColor: 'var(--goia-orange)', color: 'var(--goia-text-on-brand)' }
                }}
              >
                Editar
              </Button>
              <Button
                fullWidth
                variant="text"
                size="small"
                startIcon={<DeleteIcon />}
                onClick={() => setOpenDeleteModal(true)}
                sx={{
                  py: 1,
                  borderRadius: 0,
                  color: 'var(--goia-danger)',
                  '&:hover': { backgroundColor: 'var(--goia-danger)', color: 'var(--goia-text-on-brand)' }
                }}
              >
                Excluir
              </Button>
            </>
          )}
        </Box>
      </Box>
    </Paper>
  );

  return (
    <>
      {renderEditModal()}
      {renderDeleteModal()}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{
            width: '100%',
            backgroundColor: snackbar.severity === 'success' ? 'var(--goia-success-100)' :
              snackbar.severity === 'error' ? 'var(--goia-danger-100)' :
                snackbar.severity === 'warning' ? 'var(--goia-warning-100)' :
                  'var(--goia-info-100)',
            color: 'var(--goia-text)',
            '& .MuiAlert-icon': {
              color: snackbar.severity === 'success' ? 'var(--goia-success)' :
                snackbar.severity === 'error' ? 'var(--goia-danger)' :
                  snackbar.severity === 'warning' ? 'var(--goia-warning)' :
                    'var(--goia-info)'
            }
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {!hasDeleted && (isMobile ? renderMobileLayout() : renderDesktopLayout())}
      <ModalComp
        open={openImportErrorModal}
        title="Erros na importação"
        subtitle="A planilha contém erros. Nenhuma alteração foi salva."
        onClose={() => setOpenImportErrorModal(false)}
      >
        <Box sx={{ maxHeight: '400px', overflow: 'auto', mb: 2 }}>
          {importErrors.map((err, idx) => {
            if (err.linha === null) {
              return (
                <Alert severity="error" key={idx} sx={{ mb: 1 }}>
                  {err.erro}
                </Alert>
              );
            }
            // Erros de validação de campo
            return (
              <Alert severity="error" key={idx} sx={{ mb: 1, whiteSpace: 'pre-wrap' }}>
                <strong>Linha {err.linha}, Coluna "{err.coluna}":</strong><br />
                {err.erro}
                <br />
                <span style={{ fontSize: '0.85rem', color: '#666' }}>
                  Valor recebido: <code>{err.valor}</code>
                </span>
              </Alert>
            );
          })}
        </Box>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          <Button variant="contained" onClick={() => setOpenImportErrorModal(false)}>
            Entendi
          </Button>
        </Box>
      </ModalComp>
    </>
  );
}